export const RECEIVE_QTY_PER_ITEM_LIMIT = 'RECEIVE_QTY_PER_ITEM_LIMIT';
export const RECEIVE_ITEM_LIMIT = 'RECEIVE_ITEM_LIMIT';
export const TOGGLE_MAX_ITEMS_REACHED = 'TOGGLE_MAX_ITEMS_REACHED';

export const toggleMaxItemsReached = (maxItemsReached) => ({
  type: TOGGLE_MAX_ITEMS_REACHED,
  data: {
    maxItemsReached,
  },
});

export const receiveItemLimit = (itemLimit) => ({
  type: RECEIVE_ITEM_LIMIT,
  data: {
    itemLimit,
  },
});

export const receiveQtyPerItemLimit = (qtyPerItemLimit) => ({
  type: RECEIVE_QTY_PER_ITEM_LIMIT,
  data: {
    qtyPerItemLimit,
  },
});

export const enableSpecialHandling = () => (dispatch, getState) => {
  const {
    page: { productType },
    returnsSettings: {
      [productType]: { specialHandlingRestrictions: { itemLimit, qtyPerItemLimit } = {} } = {},
    } = {},
  } = getState();

  if (itemLimit) dispatch(receiveItemLimit(itemLimit));
  if (qtyPerItemLimit) dispatch(receiveQtyPerItemLimit(qtyPerItemLimit));
};
